import { useGetPassportReport } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function PassportReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      title={t('common:passport-report')}
      usePivotQuery={useGetPassportReport}
      completeName={['customer', 'admin', 'guest', 'status']}
    />
  );
}
